// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Black+Ops+One&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Archivo+Black&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";



html, body {
  font-family: 'Roboto';
  background-color: #f3f5f8;
}



a {
  text-decoration: none;
  color: #0b49ff;
}


.embla {
  max-width: 100vw;
  margin: auto;
  --slide-height: 19rem;
  --slide-spacing: 1rem;
}
.embla__viewport {
  overflow: hidden;
}
.embla__container {
  display: flex;
  touch-action: pan-y pinch-zoom;
  margin-left: calc(var(--slide-spacing) * -1);
}
.embla__slide {
  transform: translate3d(0, 0, 0);
  flex: 0 0 var(--slide-size);
  min-width: 0;
  padding-left: var(--slide-spacing);
}
.embla__slide__number {
  position: relative;
  border: 1px solid #777;
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  border-radius: 1.8rem;
  font-size: 4rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}
.embla__controls {
  display: flex;
  justify-content: center;
  margin-top: 0.8rem;
}
.embla__buttons {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.6rem;
  align-items: center;
}
.embla__button {
  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  width: 3.6rem;
  height: 3.6rem;
  z-index: 1;
  border-radius: 50%;
  border: 1px solid #ccc;
  color: var(--text-body);
  display: flex;
  align-items: center;
  justify-content: center;
}
.embla__button:disabled {
  color: var(--detail-high-contrast);
}
.embla__button__svg {
  width: 35%;
  height: 35%;
}
.embla__play {
  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  touch-action: manipulation;
  display: inline-flex;
  text-decoration: none;
  cursor: pointer;
  border: 0;
  padding: 0;
  margin: 0;
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  border-radius: 1.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  color: var(--text-body);
  font-weight: 700;
  font-size: 1.4rem;
  padding: 0 2.4rem;
  min-width: 8.4rem;
}
.embla__progress {
  border-radius: 1.8rem;
  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);
  background-color: var(--background-site);
  position: relative;
  height: 0.6rem;
  justify-self: flex-end;
  align-self: center;
  width: 13rem;
  max-width: 90%;
  overflow: hidden;
}
.embla__progress__bar {
  background-color: var(--text-body);
  position: absolute;
  width: 100%;
  top: 0;
  bottom: 0;
  left: -100%;
}
.embla__controls {
  grid-template-columns: auto 1fr auto;
}
.embla__progress {
  justify-self: center;
  transition: opacity 0.3s ease-in-out;
  width: 8rem;
}
.embla__progress--hidden {
  opacity: 0;
}
.embla__progress__bar {
  animation-name: autoplay-progress;
  animation-timing-function: linear;
  animation-iteration-count: 1;
}
.embla__progress--hidden .embla__progress__bar {
  animation-play-state: paused;
}
@keyframes autoplay-progress {
  0% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(100%, 0, 0);
  }
}


/* Overlay : totalement "click-through" */
.vidoverlay {
  --space: 12px;            /* distance entre points/lignes */
  --dot-size: 1.2px;        /* diamètre des points */
  --ink: 255,255,255;       /* teinte (blanc) — change pour une autre couleur */
  --alpha: 0.8;             /* opacité globale du motif */

  position: absolute;
  inset: 0;
  pointer-events: none;     /* ne bloque pas les interactions sur la vidéo */
  z-index: 2;

  /* léger vignettage pour le style (optionnel) */
  box-shadow: inset 0 0 120px rgba(0,0,0,.5);
}

/* Motif "points" via radial-gradient répété */
.vidoverlay.dots {
  background-image:
    radial-gradient(rgba(var(--ink), var(--alpha)) var(--dot-size), transparent calc(var(--dot-size) + 0.01px));
  background-size: var(--space) var(--space);
  /* Donne un rendu plus "fusionné" avec l'image ; enlève si tu préfères net */
  mix-blend-mode: overlay;
}

/* Motif "grille" via deux linear-gradients */
.vidoverlay.grid {
  background-image:
    linear-gradient(rgba(var(--ink), var(--alpha)) 1px, transparent 1px),
    linear-gradient(90deg, rgba(var(--ink), var(--alpha)) 1px, transparent 1px);
  background-size: var(--space) var(--space);
  mix-blend-mode: overlay;
}


.clear-both {
  clear: both; }

.white-round-container {
  background: #fff;
  width: 1020px;
  border-radius: 6px;
  border: 0.5pt solid #ddd; }

.padding-10 {
  padding: 10px; }

.padding-20 {
  padding: 20px; }

.global-activeuser-changed-icon {
  width: 60px;
  height: 60px;
  line-height: 65px;
  text-align: center;
  background: #8dc82c;
  border-radius: 50%;
  font-size: 45px;
  color: #FFF;
  margin: auto;
  margin-top: 30px; }

.page-title {
  color: #222;
  font-size: 35px;
  font-weight: bold;
  line-height: 40px;
}

.sigPadContainer {
  background-color: rgb(238, 235, 235);
  padding: 0 10px 10px;
}
.sigCanvas{
  width: 100%;
  height: 200px;
}

.modalContainer {
  position: fixed;
  width: 100vw;
  height: 100%;
  display: flex;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.6);
}
​
.modal{
  width: 90%;
  max-width: 500px;
  border: 5px;
  padding: 10px;
  background-color: white;
  box-sizing: border-box;
}


.blue-button-pc {
  cursor: pointer;
  background: #0079ff;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}

.blue-button-disabled-pc {
  opacity: 0.3;
  cursor: default;
  background: #0079ff;
  text-align: center;
  line-height: 60px;
  color: #fff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}

.cancel-button-pc {
  cursor: pointer;
  background: #fff;
  text-align: center;
  line-height: 60px;
  color: #0079ff;
  font-size: 1.5rem;
  border: 0.5px solid #0079ff;
  width: 230px;
  height: 60px;
  border-radius: 6px
}



.blue-button-phone {
  cursor: pointer;
  background: #0079ff;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}

.blue-button-disabled-phone {
  opacity: 0.3;
  cursor: default;
  background: #0079ff;
  text-align: center;
  line-height: 50px;
  color: #fff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}

.cancel-button-phone {
  cursor: pointer;
  background: #fff;
  text-align: center;
  line-height: 50px;
  color: #0079ff;
  font-size: 1rem;
  border: 0.5px solid #0079ff;
  width: 160px;
  height: 50px;
  border-radius: 6px
}


.gradient-text {
  background: linear-gradient(to right, #00c6ff, #0072ff, #ff6a00, #ee0979);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* pour compatibilité étendue */
  color: transparent;
}


.gradient-text-b {
  background: linear-gradient(to right, #4300e6, #237f8c, #1d9b69, #1d9b69);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* pour compatibilité étendue */
  color: transparent;
}


.skeleton {
  margin-right: 20px;
  background-color: #ccc;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #777;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.skeleton::after {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  height: 100%;
  width: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);
  animation: shimmer 2s infinite;
}

@keyframes shimmer {
  0% { transform: translateX(0); }
  100% { transform: translateX(100%); }
}


.popup-box {
  overflow: hidden;
  position: relative;
  min-width: 280px;
  border-radius: 8px;
}

.popup-container {
  background: white;
  width: 100%;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
}

.close-button {
  background: none;
  border: none;
  font-size: 16px;
  cursor: pointer;
  color: #888;
}

.tabs {
  display: flex;
  gap: 10px;
  border-bottom: 1px solid #ddd;
}

.tab-button {
  background: none;
  border: none;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 16px;
  transition: transform 0.2s ease;
  border-bottom: 4px solid #fff;
}

.tab-button:hover {
  transform: scale(1);
  background-color: #eff2fb;
}

.tab-button.active {
  border-bottom: 4px solid #0b49ff;
  color: #0b49ff;
}


.tab-button-phone {
  background: none;
  border: none;
  padding: 4px 6px;
  cursor: pointer;
  font-size: 13px;
  transition: transform 0.2s ease;
  border-bottom: 4px solid #fff;
}

.tab-button-phone:hover {
  transform: scale(1);
  background-color: #eff2fb;
}

.tab-button-phone.active {
  border-bottom: 4px solid #0b49ff;
  color: #0b49ff;
}


.tab-icon {
  display: flex;
  align-items: center;
  gap: 6px;
}

.icon .reaction-img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}


.tab-icon-phone {
  display: flex;
  align-items: center;
  gap: 0px;
}
.icon-phone .reaction-img {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.count {
  font-size: 13px;
  color: #555;
}

.popup-content {
  background-color: 'yellow';
  overflow-y: auto;
  flex: 1;
}

.reaction-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 0;
}

.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ccc;
}

.no-reactions {
  text-align: center;
  color: #888;
  font-size: 14px;
  margin-top: 20px;
}


.reaction-container {
  position: relative;
  display: inline-block;
}

.react-button {
  padding: 8px 12px;
  background: #fafafa;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.react-button-selected {
  padding: 8px 12px;
  background: #f2f5fc;
  border: 1px solid #0b49ff;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.button-icon {
  width: 20px;
  height: 20px;
}



.reaction-popover {
  position: absolute;
  top: -10px;
  left: -10px;
  transform: translateX(0%) translateY(-10%);
  background: white;
  border-radius: 40px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  padding: 8px 10px;
  display: flex;
  gap: 13px;
  z-index: 100;
}

.reaction-popover-mobile {
  position: absolute;
  top: 0px;
  left: 0px;
  transform: translateX(0%) translateY(-10%);
  background: white;
  border-radius: 40px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.3);
  padding: 8px 10px;
  display: flex;
  gap: 13px;
  z-index: 100;
}

.reaction-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.reaction-item:hover {
  transform: scale(1.2);
}

.reaction-item.active .reaction-icon {
  border: 2px solid #4300ea;
  border-radius: 50%;
  padding: 2px;
}

.reaction-icon {
  width: 50px;
  height: 50px;
}

.counter {
  margin-top: 4px;
  font-size: 12px;
  background: #eee;
  padding: 2px 6px;
  border-radius: 10px;
}

.tooltip {
  position: absolute;
  bottom: -30px;
  background: #4300ea;
  color: white;
  padding: 4px 8px;
  font-size: 11px;
  border-radius: 4px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s ease;
  white-space: nowrap;
}

.reaction-item:hover .tooltip {
  opacity: 1;
}

.slider-container {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: auto;
  overflow: hidden;
}

.image-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
}

.slider-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
  position: absolute;
  top: 0;
  left: 0;
}

.arrow {
  font-size: 40px;
  padding: 10px;
  cursor: pointer;
  z-index: 2;
  color: white;
  user-select: none;
  background-color: rgba(255,255,255,0.1);
}


.card-content-wrapper{
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 1) !important; /* modifie le shadow */
  border-radius: 0px !important; /* arrondi les coins */
}




.text {
  overflow: hidden;
  transition: max-height 0.3s ease;
}

.collapsed {
  max-height: 120px; /* ajustable selon besoin */
}

.expanded {
  max-height: 1000px;
}

.toggle-button {
  margin-top: 5px;
  background: none;
  border: 1px solid #0b49ff;
  color: #0b49ff;
  cursor: pointer;
  padding: 10px;
  border-radius: 4px;
}

.carousel-wrapper {
  position: relative;
  overflow: visible;
}

.carousel {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0 60px;
  padding-bottom: 40px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge */
}

.carousel::-webkit-scrollbar {
  display: none;
}

.item {
  margin-right: 20px;
  background-color: #ddd;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #777;
  flex-shrink: 0;
  display: flex;
  align-items: flex-end;
  padding-bottom: 20px;
  justify-content: center;
  cursor: pointer;
  position: relative;
  z-index: 1;
}

.card-image {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  top: 0;
  left: 0;
}

/* Overlay texte en bas */
.text-overlay {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  z-index: 2;
}

/* Dégradé juste au-dessus du texte */
.text-gradient {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc(3.5em + 10px);
  background: linear-gradient(to top, rgba(0, 0, 0, 1), transparent);
  z-index: 1;
  pointer-events: none;
}

/* Texte blanc lisible avec ombre */
.overlay-text {
  position: relative;
  color: white;
  text-shadow: 0 2px 6px rgba(0, 0, 0, 1);
  margin: 10px;
  z-index: 2;
}

.zoom-preview {
  position: absolute;
  background-color: #f4f4f4;
  border-radius: 12px;
  height: 290px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  pointer-events: none;
}

.item-wrapper {
  position: relative;
  width: 300px;
  height: 200px;
  margin-right: 12px;
  flex-shrink: 0;
}

.item-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ddd;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
}

.item-selected {
  width: 500px;
  height: 350px;
  background-color: green;
  margin-right: 12px;
  border-radius: 10px;
  flex-shrink: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: box-shadow 0.3s ease;
  position: relative;
  margin-top: -100px;
  z-index: 999;
}


.scroll-snap-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.header-section {
  height: 33vh;
}


.scroll-area {
  height: 100vh;
  scroll-snap-type: y mandatory;
  overflow-y: scroll;
  transition: scroll-snap-type 0.3s ease-in-out;
}

.disable-scroll-area {
  overflow-y: scroll;
}

._scroll-area {
  max-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  position: relative;
}

.section {
  height: 100vh;
  scroll-snap-align: start;
}

.credits-gradient-text {
  background: linear-gradient(to right, #3e00e6, #2a63a8, #2a63a8, #1c9a68, #1c9a68, #1c9a68, #1c9a68, #1c9a68, #1c9a68);
  display: inline-block;
  min-width: 200px; /* donne de l'espace au gradient */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; /* pour compatibilité étendue */
  color: transparent;
}

.full-page {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 100vh;
      width: 100%;
}

.home-full-page {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 85vh;
      width: 100%;
}



.header-full-page-pc {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 'auto';
      width: 100%;
}

.sticky-header-full-page-pc {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 60px;
      width: 100%;
}

.sticky-header-full-page-phone {
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      height: 130px;
      width: 100%;
}




.video-container {
  position: relative;
  width: 100%;
  height: 100vh; /* full viewport height */
  overflow: hidden;
}

.video-bg {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.video-bg-mobile {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-42%, -50%);
  object-fit: cover;
}


.video-bg-tablet {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-42%, -50%);
  object-fit: cover;
}

.video-bg-mobile-flag {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-50%, -50%);
  object-fit: cover;
}


.video-bg-tablet-flag {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  z-index: 0;
  transform: translate(-50%, -50%);
  object-fit: cover;
}

.content-overlay {
  position: relative;
  z-index: 1;
  color: white;
  text-align: center;
  padding-top: 20vh;
}



.gradient-box {
  background: linear-gradient(to right, #333ac9, #1b9868);
}

@keyframes shine {
  0% { background-position: -200% 0; }
  100% { background-position: 200% 0; }
}

.gradient-background {
  background-color: #dcddf7;
  position: relative;
  overflow: hidden;
}

.gradient-background::after {
  content: "";
  position: absolute;
  top: 80%;
  left: 0;
  width: 100%;
  height: 20%;
  background: linear-gradient(to bottom, rgba(220, 221, 247, 1), rgba(220, 221, 247, 0));
  pointer-events: none;
}

/* Text Input */
.basic_ti{
	height:40px;
	padding:6px;
	background:#fff;width:358px;
	border:1px solid #111;
	border-radius:4px;
}
.basic_ti_top{
	height:40px;
	padding:6px;
	background:#fff;
  width:358px;
	border:1px solid #111;
	border-radius:4px;
	border-bottom:none;
	-moz-border-radius-bottomleft:0px;
		-webkit-border-bottom-left-radius:0px;
		border-bottom-left-radius:0px;
		-moz-border-radius-bottomright:0px;
		-webkit-border-bottom-right-radius:0px;
		border-bottom-right-radius:0px;
}
.basic_ti_middle{
	height:40px;
	padding:6px;
	background:#fff;
  width:358px;
	border:1px solid #111;border-top:1px solid #bbb;
	border-bottom:none;
	border-radius:none;
	-moz-border-radius-topleft:0px;
			-webkit-border-radius:0px;
			border-radius:0px;
			-moz-border-radius:0px;
			-webkit-border-radius:0px;
			border-radius:0px;
}
.basic_ti_bottom{
	height:40px;
	padding:6px;
	background:#fff;width:358px;
      border-radius:4px;
	border:1px solid #111;border-top:1px solid #bbb;
	-moz-border-radius-topleft:0px;
			-webkit-border-top-left-radius:0px;
			border-top-left-radius:0px;
			-moz-border-radius-topright:0px;
			-webkit-border-top-right-radius:0px;
			border-top-right-radius:0px;
}

/* BUTTON */
.buttonBlackText {
	color: #000;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
    line-height: 50px;
   border-radius: 6px;
   cursor:pointer;
}

.buttonWhiteText {
	color: #fff;
      font-size: 1.3rem;
     font-weight: 400;
     text-align: center;
     width: 200px ;
	 height: 50px;
     justify-content: center;
    line-height: 50px;
   border-radius: 6px;
   cursor:pointer;
}



.sp-lp-title-pc {
  font-size: 2rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .sp-lp-title-pc {
    font-size: 2.5rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .sp-lp-title-pc {
    font-size: 2.8rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}


.sp-lp-title-sub-pc {
  font-size: 1.7rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .sp-lp-title-sub-pc {
    font-size: 2.2rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .sp-lp-title-sub-pc {
    font-size: 2.5rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}


.sp-lp-title-tablet {
  font-size: 1.9rem;
  line-height: 2.2rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}

.sp-lp-title-sub-tablet {
  font-size: 1.7rem;
  line-height: 2.2rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}


.sp-lp-title-phone {
  font-size: 1.1rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}

.sp-lp-title-sub-phone {
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}


.sp-lp-h3-pc {
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .sp-lp-h3-pc {
    font-size: 1.2rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .sp-lp-h3-pc {
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}



.sp-lp-description-pc {
  font-size: 0.9rem;
  line-height: 1.1rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .sp-lp-description-pc {
    font-size: 1.1rem;
    line-height: 1.3rem;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .sp-lp-description-pc {
    font-size: 1.3rem;
    line-height: 1.5rem;
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
    color: #fff;
  }
}

.sp-lp-description-phone {
  font-size: 0.9rem;
  line-height: 1.0rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}

.sp-lp-description-tablet {
  font-size: 1.3rem;
  line-height: 1.6rem;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
  color: #fff;
}

.no-sp-inner-shadow {
  font: bold 30px arial, sans-serif;
  text-align: center;
  background-color: #56626e;
  color: transparent;
  text-shadow: 2px 2px 3px rgba(255,255,255,0.5);
  -webkit-background-clip: text;
     -moz-background-clip: text;
          background-clip: text;
}


.sp-lp-button-text-white-inner-pc {
  font-size: 0.9rem;
  color: #fff;
  text-shadow: 1px 1px 0 #999,
              -1px -1px 0 #555;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .sp-lp-button-text-white-inner-pc {
    font-size: 1.2rem;
    color: #fff;
    text-shadow: 1px 1px 0 #999,
                -1px -1px 0 #555;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .sp-lp-button-text-white-inner-pc {
    font-size: 1.5rem;
    color: #fff;
    text-shadow: 1px 1px 0 #999,
                -1px -1px 0 #555;
  }
}




.hero-section {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.parallax-bg {
  position: absolute;
  inset: 0;
  z-index: 0;
}

.hero-content {
  position: relative;
  z-index: 10;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 0 1rem;
}

.hero-title {
  color: #fff;
  font-size: 3rem;
  line-height: 3.1rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}



.highlight {
  color: #facc15; /* jaune doré */
}

.hero-subtitle {
  margin-top: 1rem;
  font-size: 2.3rem;
  line-height: 2rem;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}






.hero-title-pc {
  color: #fff;
  font-size: 2.4rem;
  line-height: 2.6rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .hero-title-pc {
    font-size: 2.6rem;
    line-height: 2.7rem;
  }
}

/* Above 1400px */
@media (min-width: 1401px) {
  .hero-title-pc {
    font-size: 3rem;
    line-height: 3.1rem;
  }
}

.hero-title-mobile {
  color: #fff;
  font-size: 2.5rem;
  line-height: 2.6rem;
  font-weight: bold;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}



.highlight {
  color: #facc15; /* jaune doré */
}

.hero-subtitle {
  margin-top: 1rem;
  font-size: 2.3rem;
  line-height: 2rem;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);
}

.big-dec-txt-pc {
  font-size: 5rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .big-dec-txt-pc {
    font-size: 6.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .big-dec-txt-pc {
    font-size: 8rem;
  }
}


.mid-dec-txt-pc {
  font-size: 3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .mid-dec-txt-pc {
    font-size: 4.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .mid-dec-txt-pc {
    font-size: 4rem;
  }
}


.mid-dec-txt-tablet {
  font-size: 3.3rem;
}

.mid-dec-txt-phone {
  font-size: 2rem;
}



.big-dec-txt-subtxt-pc {
  font-size: 1.6rem;
  line-height: 1.8rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .big-dec-txt-subtxt-pc {
    font-size: 1.8rem;
    line-height: 2rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .big-dec-txt-subtxt-pc {
    font-size: 2rem;
    line-height: 2.2rem;
  }
}






.small-box-txt-sz-pc {
  font-size: 21px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .small-box-txt-sz-pc {
    font-size: 25px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .small-box-txt-sz-pc {
    font-size: 5rem;
  }
}


.small-box-small-txt-sz-pc {
  font-size: 17px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .small-box-small-txt-sz-pc {
    font-size: 18px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .small-box-small-txt-sz-pc {
    font-size: 20px;
  }
}


.page-title-phone {
  font-size: 1.8rem;
}


.page-title-pc {
  font-size: 2.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-title-pc {
    font-size: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-title-pc {
    font-size: 2.7rem;
  }
}

.page-subtitle-pc {
  font-size: 2rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-subtitle-pc {
    font-size: 2.3rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-subtitle-pc {
    font-size: 2.5rem;
  }
}


.page-subsubtitle-pc {
  font-size: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .page-subsubtitle-pc {
    font-size: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .page-subsubtitle-pc {
    font-size: 1.7rem;
  }
}


.page-subsubtitle-phone {
  font-size: 1rem;
  line-height: 1.2rem;
}


.menu-name-pc {
  font-size: 16px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .menu-name-pc {
    font-size: 17px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .menu-name-pc {
    font-size: 18px;
  }
}


.menu-name-tablet {
  font-size: 17px;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .menu-name-tablet {
    font-size: 18px;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .menu-name-tablet {
    font-size: 19px;
  }
}


.motion-h1-pc {
  font-size: 2rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-h1-pc {
    font-size: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-h1-pc {
    font-size: 2.8rem;
  }
}

.motion-h1-sub-pc {
  font-size: 1.7rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-h1-sub-pc {
    font-size: 1.8rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-h1-sub-pc {
    font-size: 1.9rem;
  }
}


.motion-h1-sub-sub-pc {
  font-size: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-h1-sub-sub-pc {
    font-size: 1.4rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-h1-sub-sub-pc {
    font-size: 1.5rem;
  }
}


.motion-h1-sub-phone {
  font-size: 1.4rem;
}


.img-border-radius-pc {
  border-radius: 0.7rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .img-border-radius-pc {
    border-radius: 0.9rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .img-border-radius-pc {
    border-radius: 1rem;
  }
}



.motion-div-small-pc {
  font-size: 1rem;
  line-height: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-small-pc {
    font-size: 1.2rem;
    line-height: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-small-pc {
    font-size: 1.5rem;
    line-height: 1.8rem;
  }
}


.motion-div-small-tablet {
  font-size: 1.3rem;
  line-height: 1.6rem;
}

.motion-div-small-phone {
  font-size: 1rem;
  line-height: 1.2rem;
}


.motion-div-smallest-tablet {
  font-size: 1.5rem;
  line-height: 1.8rem;
}

.motion-div-smallest-phone {
  font-size: 1.0rem;
  line-height: 1.3rem;
}


.motion-div-smallest-pc {
  font-size: 0.9rem;
  line-height: 1.1rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-smallest-pc {
    font-size: 1.1rem;
    line-height: 1.3rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-smallest-pc {
    font-size: 1.3rem;
    line-height: 1.5rem;
  }
}



.motion-div-default-pc {
  font-size: 1.1rem;
  line-height: 1.3rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-default-pc {
    font-size: 1.3rem;
    line-height: 1.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-default-pc {
    font-size: 1.6rem;
    line-height: 1.9rem;
  }
}



.motion-div-title-pc {
  font-size: 1.7rem;
  line-height: 1.9rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-title-pc {
    font-size: 2.3rem;
    line-height: 2.5rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-title-pc {
    font-size: 2.5rem;
    line-height: 2.7rem;
  }
}



.motion-div-subtitle-pc {
  font-size: 1.4rem;
  line-height: 1.6rem;
}
/* Between 1201px and 1400px */
@media (min-width: 1201px) and (max-width: 1400px) {
  .motion-div-subtitle-pc {
    font-size: 2rem;
    line-height: 2.2rem;
  }
}
/* Above 1400px */
@media (min-width: 1401px) {
  .motion-div-subtitle-pc {
    font-size: 2.2rem;
    line-height: 2.4rem;
  }
}





.blurred-transp-bg {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.menu-modal-transl {
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}


/* HEADER */
.main_header {
  position:fixed;
	z-index:19;
	top:10px;
	right: 25px;
   width: 100%;
   height: 70px;
  border-bottom: rgba(53,3,176,1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.main_header_okd {
	position:fixed;
	z-index:99;
	top:0;
	left: 0;
   width: 100%;
   height: 70px;
  border-bottom: rgba(53,3,176,1);
  background: rgb(53,3,176);
background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3503b0",endColorstr="#9e10bf",GradientType=1);
}

.main_header_connected{
	position:fixed;
	z-index:9;
	top:0;
	left: 0;
   width: 100%;
   height: 70px;
   background: rgb(53,3,176);
 background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);
 filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#3503b0",endColorstr="#9e10bf",GradientType=1);
  overflow: hidden;
}


.main_header_inside {
	width: 98%;
       height: 60px;
	margin: auto;
	margin-top:5px;
      overflow: hidden;
}

.main_header_inside_mobile {
	width: 98%;
       height: 50px;
	margin: auto;
	margin-top:5px;
      overflow: hidden;
}




.main_header_inside_left {
       width: 170px;
       height: 50px;
	    justify-content: center;
	   line-height: 50px;
	   float: left;
}

.main_header_inside_left_2 {
       height: 65px;
	    justify-content: center;
	   line-height: 65px;
	   float: left;
	   margin-left: 50px;
}

.main_header_inside_left_2 a{
	display: inline-block;
	text-align: center;
	font-size: 17px;
  margin-right: 25px
}


.main_header_inside_left img{
	width: 170px;
	 vertical-align: middle;
}

.main_header_inside_left_mobile {
	width: 30%;
       height: 50px;
	    justify-content: center;
	   line-height: 50px;
	   float: left;
}
.main_header_inside_left_mobile img{
	width: 100%;
	 vertical-align: middle;
}



.main_header_inside_center {
	margin-left: 20px;
	width: 480px;
       height: 44px;
	   margin-top:3px;
    justify-content: center;
	 float: left;
}




.main_header_inside_center_mobile {
	text-align:  center;
	width: 40%;
       height: 50px;
	   line-height: 50px;
	   float: left;
}
.main_header_inside_center_mobile img{
	width: 100%;
	 vertical-align: middle;
}


.main_header_inside_right {
	position: relative;
	text-align:  right;
	width: 350px;
       height: 50px;
	   float: right;
}
.main_header_inside_right img{
	height: 50px;
	 vertical-align: middle;
}


.main_header_inside_right_1 {
	position: relative;
	   float: right;
	   margin-left:20px;
	     margin-top:5px;
}

.main_header_inside_right_2 {
	position: relative;
	   float: right;
	   margin-top:5px;
}


.main_header_inside_right_mobile {
	position: relative;
	text-align:  right;
	width: 30%;
       height: 50px;
	     line-height: 50px;
	   float: right;
}
.main_header_inside_right_mobile img{
	width: 100%;
	 vertical-align: middle;
}



.menu_container {
  position: fixed;
  top: 19px;
  right: 7px;
  height: 27px;
  width: 35px;
  cursor: pointer;
  z-index: 9999;
  transition: opacity .25s ease;

  &:hover {
    opacity: 1;
  }

  &.active {
    .top {
      transform: translateY(11px) translateX(0) rotate(45deg);
      background: #777;
    }
    .middle {
      opacity: 0;
      background: #777;
    }

    .bottom {
      transform: translateY(-11px) translateX(0) rotate(-45deg);
      background: #777;
    }
  }

  span {
  background: #fff;
  border: none;
  height: 3px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  transition:  all .35s ease;
  cursor: pointer;

    &:nth-of-type(2) {
      top: 11px;
    }

    &:nth-of-type(3) {
      top: 22px;
    }
  }
}



.overlay {
  position: fixed;
   z-index: 10;
  background: #fff;
  top: 0;
  left: 0;
  width: 100%;
  height: 0%;
  opacity: 0;
  visibility: hidden;
  transition: opacity .35s, visibility .35s, height .35s;
  overflow: hidden;

  &.open {
    opacity: 1;
    visibility: visible;
    height: 100%;

    li {
      animation: fadeInRight .5s ease forwards;
      animation-delay: .35s;

      &:nth-of-type(2) {
        animation-delay: .4s;
      }
      &:nth-of-type(3) {
        animation-delay: .45s;
      }
      &:nth-of-type(4) {
        animation-delay: .50s;
      }
    }
  }
  nav {
    position: relative;
    height: 70%;
    top: 35%;
    transform: translateY(-50%);
    font-size: 20px;
    font-family: 'Lato', sans-serif;
    font-weight: 400;
    text-align: center;
    width: 98% ;
	margin: auto;
  }
  ul {
    list-style: none;
    padding: 0;
    margin: 0 auto;
    display: inline-block;
    position: relative;
    height: 100%;
     width: 100% ;

    li {
      display: block;
      height: 50px;
      min-height: 50px;
	  line-height: 50px;
	  width: 100% ;
      position: relative;
      opacity: 0;

      a {
        display: block;
        position: relative;
        color: #333;
        text-decoration: none;
        overflow: hidden;
        vertical-align: middle;

        &:hover:after,
         &:focus:after,
         &:active:after {
           width: 100%;
         }

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          width: 0%;
          transform: translateX(-50%);
          height: 3px;
          background: #FFF;
          transition: .35s;
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,gBAAgB;;;;AAOhB;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;;;AAIA;EACE,qBAAqB;EACrB,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,qBAAqB;AACvB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,4DAA4D;EAC5D,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,2EAA2E;EAC3E,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,4DAA4D;EAC5D,aAAa;EACb,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,2EAA2E;EAC3E,wBAAwB;EACxB,gBAAgB;EAChB,6BAA6B;EAC7B,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,SAAS;EACT,UAAU;EACV,SAAS;EACT,4DAA4D;EAC5D,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,4DAA4D;EAC5D,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,kCAAkC;EACpC;AACF;;;AAGA,yCAAyC;AACzC;EACE,aAAa,aAAa,iCAAiC;EAC3D,iBAAiB,SAAS,wBAAwB;EAClD,kBAAkB,QAAQ,mDAAmD;EAC7E,YAAY,cAAc,6BAA6B;;EAEvD,kBAAkB;EAClB,QAAQ;EACR,oBAAoB,MAAM,gDAAgD;EAC1E,UAAU;;EAEV,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;EACE;+GAC6G;EAC7G,0CAA0C;EAC1C,4EAA4E;EAC5E,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE;;+EAE6E;EAC7E,0CAA0C;EAC1C,uBAAuB;AACzB;;;AAGA;EACE,WAAW,EAAE;;AAEf;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,wBAAwB,EAAE;;AAE5B;EACE,aAAa,EAAE;;AAEjB;EACE,aAAa,EAAE;;AAEjB;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB,EAAE;;AAEpB;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;EACnB,oCAAoC;AACtC;AACA;;EAEE,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,sBAAsB;AACxB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;;;AAIA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ;AACF;;;AAGA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB,EAAE,+BAA+B;EACtD,kBAAkB;AACpB;;;AAGA;EACE,yEAAyE;EACzE,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB,EAAE,+BAA+B;EACtD,kBAAkB;AACpB;;;AAGA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mFAAmF;EACnF,8BAA8B;AAChC;;AAEA;EACE,KAAK,wBAAwB,EAAE;EAC/B,OAAO,2BAA2B,EAAE;AACtC;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;;AAGA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;EACtC,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;;AAEA;EACE,eAAe;EACf,aAAa;EACb,eAAe;EACf,UAAU;EACV,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;AACzC;;;AAGA;EACE,mDAAmD,EAAE,sBAAsB;EAC3E,6BAA6B,EAAE,sBAAsB;AACvD;;;;;AAKA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,YAAY;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,MAAM;EACN,OAAO;AACT;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,kEAAkE;EAClE,UAAU;EACV,oBAAoB;AACtB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,sHAAsH;EACtH,qBAAqB;EACrB,gBAAgB,EAAE,kCAAkC;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB,EAAE,+BAA+B;EACtD,kBAAkB;AACpB;;AAEA;MACM,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;MAC5B,aAAa;MACb,WAAW;AACjB;;AAEA;MACM,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;MAC5B,YAAY;MACZ,WAAW;AACjB;;;;AAIA;MACM,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;MAC5B,cAAc;MACd,WAAW;AACjB;;AAEA;MACM,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;MAC5B,YAAY;MACZ,WAAW;AACjB;;AAEA;MACM,sBAAsB;MACtB,2BAA2B;MAC3B,4BAA4B;MAC5B,aAAa;MACb,WAAW;AACjB;;;;;AAKA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa,EAAE,yBAAyB;EACxC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;;;AAIA;EACE,uDAAuD;AACzD;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,sFAAsF;EACtF,oBAAoB;AACtB;;AAEA,eAAe;AACf;CACC,WAAW;CACX,WAAW;CACX,eAAe,CAAC,WAAW;CAC3B,qBAAqB;CACrB,iBAAiB;AAClB;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe;EACd,WAAW;CACZ,qBAAqB;CACrB,iBAAiB;CACjB,kBAAkB;CAClB,iCAAiC;EAChC,qCAAqC;EACrC,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,8BAA8B;AAChC;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe;EACd,WAAW;CACZ,qBAAqB,CAAC,yBAAyB;CAC/C,kBAAkB;CAClB,kBAAkB;CAClB,8BAA8B;GAC5B,yBAAyB;GACzB,iBAAiB;GACjB,sBAAsB;GACtB,yBAAyB;GACzB,iBAAiB;AACpB;AACA;CACC,WAAW;CACX,WAAW;CACX,eAAe,CAAC,WAAW;MACtB,iBAAiB;CACtB,qBAAqB,CAAC,yBAAyB;CAC/C,8BAA8B;GAC5B,kCAAkC;GAClC,0BAA0B;GAC1B,+BAA+B;GAC/B,mCAAmC;GACnC,2BAA2B;AAC9B;;AAEA,WAAW;AACX;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;IACxB,iBAAiB;GAClB,kBAAkB;GAClB,cAAc;AACjB;;AAEA;CACC,WAAW;MACN,iBAAiB;KAClB,gBAAgB;KAChB,kBAAkB;KAClB,aAAa;EAChB,YAAY;KACT,uBAAuB;IACxB,iBAAiB;GAClB,kBAAkB;GAClB,cAAc;AACjB;;;;AAIA;EACE,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;;;AAGA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,iBAAiB;IACjB,yCAAyC;IACzC,WAAW;EACb;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;EACb;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,WAAW;EACb;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,6BAA6B;KAC1B,0BAA0B;UACrB,qBAAqB;AAC/B;;;AAGA;EACE,iBAAiB;EACjB,WAAW;EACX;8BAC4B;AAC9B;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,WAAW;IACX;gCAC4B;EAC9B;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,WAAW;IACX;gCAC4B;EAC9B;AACF;;;;;AAKA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;;;AAIA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;AAC3C;;;;;;;AAOA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,yCAAyC;AAC3C;;;;AAIA;EACE,cAAc,EAAE,eAAe;AACjC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;;;;;;;AAOA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;EACjB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,eAAe;EACjB;AACF;;;AAGA;EACE,eAAe;AACjB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,iBAAiB;AACnB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;EACnB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;EACnB;AACF;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,qBAAqB;AACvB;AACA,8BAA8B;AAC9B;EACE;IACE,qBAAqB;EACvB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,mBAAmB;EACrB;AACF;;;;AAIA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;;AAGA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;AAIA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE;IACE,eAAe;IACf,mBAAmB;EACrB;AACF;AACA,iBAAiB;AACjB;EACE;IACE,iBAAiB;IACjB,mBAAmB;EACrB;AACF;;;;;;AAMA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;;AAGA,WAAW;AACX;EACE,cAAc;CACf,UAAU;CACV,QAAQ;CACR,WAAW;GACT,WAAW;GACX,YAAY;EACb,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;CACC,cAAc;CACd,UAAU;CACV,KAAK;CACL,OAAO;GACL,WAAW;GACX,YAAY;EACb,+BAA+B;EAC/B,yBAAyB;AAC3B,qFAAqF;AACrF,wFAAwF;AACxF,gFAAgF;AAChF,gHAAgH;AAChH;;AAEA;CACC,cAAc;CACd,SAAS;CACT,KAAK;CACL,OAAO;GACL,WAAW;GACX,YAAY;GACZ,yBAAyB;CAC3B,qFAAqF;CACrF,wFAAwF;CACxF,gFAAgF;CAChF,gHAAgH;EAC/G,gBAAgB;AAClB;;;AAGA;CACC,UAAU;OACJ,YAAY;CAClB,YAAY;CACZ,cAAc;MACT,gBAAgB;AACtB;;AAEA;CACC,UAAU;OACJ,YAAY;CAClB,YAAY;CACZ,cAAc;MACT,gBAAgB;AACtB;;;;;AAKA;OACO,YAAY;OACZ,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;AACf;;AAEA;OACO,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;IACX,iBAAiB;AACrB;;AAEA;CACC,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;EACd;AACF;;;AAGA;CACC,YAAY;EACX,sBAAsB;AACxB;;AAEA;CACC,UAAU;OACJ,YAAY;KACd,uBAAuB;IACxB,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;;AAIA;CACC,iBAAiB;CACjB,YAAY;OACN,YAAY;IACf,cAAc;IACd,uBAAuB;EACzB,WAAW;AACb;;;;;AAKA;CACC,mBAAmB;CACnB,UAAU;OACJ,YAAY;IACf,iBAAiB;IACjB,WAAW;AACf;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;OACN,YAAY;IACf,YAAY;AAChB;AACA;CACC,YAAY;EACX,sBAAsB;AACxB;;;AAGA;CACC,kBAAkB;IACf,YAAY;IACZ,gBAAgB;MACd,cAAc;AACpB;;AAEA;CACC,kBAAkB;IACf,YAAY;IACZ,cAAc;AAClB;;;AAGA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,UAAU;OACJ,YAAY;MACb,iBAAiB;IACnB,YAAY;AAChB;AACA;CACC,WAAW;EACV,sBAAsB;AACxB;;;;AAIA;EACE,eAAe;EACf,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,eAAe;EACf,aAAa;EACb,6BAA6B;;EAE7B;IACE,UAAU;EACZ;;EAEA;IACE;MACE,uDAAuD;MACvD,gBAAgB;IAClB;IACA;MACE,UAAU;MACV,gBAAgB;IAClB;;IAEA;MACE,yDAAyD;MACzD,gBAAgB;IAClB;EACF;;EAEA;EACA,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,0BAA0B;EAC1B,eAAe;;IAEb;MACE,SAAS;IACX;;IAEA;MACE,SAAS;IACX;EACF;AACF;;;;AAIA;EACE,eAAe;GACd,WAAW;EACZ,gBAAgB;EAChB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,sDAAsD;EACtD,gBAAgB;;EAEhB;IACE,UAAU;IACV,mBAAmB;IACnB,YAAY;;IAEZ;MACE,wCAAwC;MACxC,qBAAqB;;MAErB;QACE,oBAAoB;MACtB;MACA;QACE,qBAAqB;MACvB;MACA;QACE,qBAAqB;MACvB;IACF;EACF;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;CACd,YAAY;EACX;EACA;IACE,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;KACX,YAAY;;IAEb;MACE,cAAc;MACd,YAAY;MACZ,gBAAgB;GACnB,iBAAiB;GACjB,YAAY;MACT,kBAAkB;MAClB,UAAU;;MAEV;QACE,cAAc;QACd,kBAAkB;QAClB,WAAW;QACX,qBAAqB;QACrB,gBAAgB;QAChB,sBAAsB;;QAEtB;;;WAGG,WAAW;SACb;;QAED;UACE,WAAW;UACX,kBAAkB;UAClB,SAAS;UACT,SAAS;UACT,SAAS;UACT,2BAA2B;UAC3B,WAAW;UACX,gBAAgB;UAChB,gBAAgB;QAClB;MACF;IACF;EACF;AACF","sourcesContent":["@charset \"UTF-8\";\n@import url(https://fonts.googleapis.com/css?family=Roboto);\n@import url(https://fonts.googleapis.com/css2?family=Black+Ops+One&display=swap);\n@import url(https://fonts.googleapis.com/css2?family=Archivo+Black&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap);\n\n\n\nhtml, body {\n  font-family: 'Roboto';\n  background-color: #f3f5f8;\n}\n\n\n\na {\n  text-decoration: none;\n  color: #0b49ff;\n}\n\n\n.embla {\n  max-width: 100vw;\n  margin: auto;\n  --slide-height: 19rem;\n  --slide-spacing: 1rem;\n}\n.embla__viewport {\n  overflow: hidden;\n}\n.embla__container {\n  display: flex;\n  touch-action: pan-y pinch-zoom;\n  margin-left: calc(var(--slide-spacing) * -1);\n}\n.embla__slide {\n  transform: translate3d(0, 0, 0);\n  flex: 0 0 var(--slide-size);\n  min-width: 0;\n  padding-left: var(--slide-spacing);\n}\n.embla__slide__number {\n  position: relative;\n  border: 1px solid #777;\n  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n  border-radius: 1.8rem;\n  font-size: 4rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n}\n.embla__controls {\n  display: flex;\n  justify-content: center;\n  margin-top: 0.8rem;\n}\n.embla__buttons {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0.6rem;\n  align-items: center;\n}\n.embla__button {\n  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: transparent;\n  touch-action: manipulation;\n  display: inline-flex;\n  text-decoration: none;\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n  width: 3.6rem;\n  height: 3.6rem;\n  z-index: 1;\n  border-radius: 50%;\n  border: 1px solid #ccc;\n  color: var(--text-body);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.embla__button:disabled {\n  color: var(--detail-high-contrast);\n}\n.embla__button__svg {\n  width: 35%;\n  height: 35%;\n}\n.embla__play {\n  -webkit-tap-highlight-color: rgba(var(--text-high-contrast-rgb-value), 0.5);\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: transparent;\n  touch-action: manipulation;\n  display: inline-flex;\n  text-decoration: none;\n  cursor: pointer;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n  border-radius: 1.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  justify-self: flex-end;\n  color: var(--text-body);\n  font-weight: 700;\n  font-size: 1.4rem;\n  padding: 0 2.4rem;\n  min-width: 8.4rem;\n}\n.embla__progress {\n  border-radius: 1.8rem;\n  box-shadow: inset 0 0 0 0.2rem var(--detail-medium-contrast);\n  background-color: var(--background-site);\n  position: relative;\n  height: 0.6rem;\n  justify-self: flex-end;\n  align-self: center;\n  width: 13rem;\n  max-width: 90%;\n  overflow: hidden;\n}\n.embla__progress__bar {\n  background-color: var(--text-body);\n  position: absolute;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  left: -100%;\n}\n.embla__controls {\n  grid-template-columns: auto 1fr auto;\n}\n.embla__progress {\n  justify-self: center;\n  transition: opacity 0.3s ease-in-out;\n  width: 8rem;\n}\n.embla__progress--hidden {\n  opacity: 0;\n}\n.embla__progress__bar {\n  animation-name: autoplay-progress;\n  animation-timing-function: linear;\n  animation-iteration-count: 1;\n}\n.embla__progress--hidden .embla__progress__bar {\n  animation-play-state: paused;\n}\n@keyframes autoplay-progress {\n  0% {\n    transform: translate3d(0, 0, 0);\n  }\n  100% {\n    transform: translate3d(100%, 0, 0);\n  }\n}\n\n\n/* Overlay : totalement \"click-through\" */\n.vidoverlay {\n  --space: 12px;            /* distance entre points/lignes */\n  --dot-size: 1.2px;        /* diamètre des points */\n  --ink: 255,255,255;       /* teinte (blanc) — change pour une autre couleur */\n  --alpha: 0.8;             /* opacité globale du motif */\n\n  position: absolute;\n  inset: 0;\n  pointer-events: none;     /* ne bloque pas les interactions sur la vidéo */\n  z-index: 2;\n\n  /* léger vignettage pour le style (optionnel) */\n  box-shadow: inset 0 0 120px rgba(0,0,0,.5);\n}\n\n/* Motif \"points\" via radial-gradient répété */\n.vidoverlay.dots {\n  background-image:\n    radial-gradient(rgba(var(--ink), var(--alpha)) var(--dot-size), transparent calc(var(--dot-size) + 0.01px));\n  background-size: var(--space) var(--space);\n  /* Donne un rendu plus \"fusionné\" avec l'image ; enlève si tu préfères net */\n  mix-blend-mode: overlay;\n}\n\n/* Motif \"grille\" via deux linear-gradients */\n.vidoverlay.grid {\n  background-image:\n    linear-gradient(rgba(var(--ink), var(--alpha)) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(var(--ink), var(--alpha)) 1px, transparent 1px);\n  background-size: var(--space) var(--space);\n  mix-blend-mode: overlay;\n}\n\n\n.clear-both {\n  clear: both; }\n\n.white-round-container {\n  background: #fff;\n  width: 1020px;\n  border-radius: 6px;\n  border: 0.5pt solid #ddd; }\n\n.padding-10 {\n  padding: 10px; }\n\n.padding-20 {\n  padding: 20px; }\n\n.global-activeuser-changed-icon {\n  width: 60px;\n  height: 60px;\n  line-height: 65px;\n  text-align: center;\n  background: #8dc82c;\n  border-radius: 50%;\n  font-size: 45px;\n  color: #FFF;\n  margin: auto;\n  margin-top: 30px; }\n\n.page-title {\n  color: #222;\n  font-size: 35px;\n  font-weight: bold;\n  line-height: 40px;\n}\n\n.sigPadContainer {\n  background-color: rgb(238, 235, 235);\n  padding: 0 10px 10px;\n}\n.sigCanvas{\n  width: 100%;\n  height: 200px;\n}\n\n.modalContainer {\n  position: fixed;\n  width: 100vw;\n  height: 100%;\n  display: flex;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  justify-content: center;\n  align-items: center;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n​\n.modal{\n  width: 90%;\n  max-width: 500px;\n  border: 5px;\n  padding: 10px;\n  background-color: white;\n  box-sizing: border-box;\n}\n\n\n.blue-button-pc {\n  cursor: pointer;\n  background: #0079ff;\n  text-align: center;\n  line-height: 60px;\n  color: #fff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n.blue-button-disabled-pc {\n  opacity: 0.3;\n  cursor: default;\n  background: #0079ff;\n  text-align: center;\n  line-height: 60px;\n  color: #fff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n.cancel-button-pc {\n  cursor: pointer;\n  background: #fff;\n  text-align: center;\n  line-height: 60px;\n  color: #0079ff;\n  font-size: 1.5rem;\n  border: 0.5px solid #0079ff;\n  width: 230px;\n  height: 60px;\n  border-radius: 6px\n}\n\n\n\n.blue-button-phone {\n  cursor: pointer;\n  background: #0079ff;\n  text-align: center;\n  line-height: 50px;\n  color: #fff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n.blue-button-disabled-phone {\n  opacity: 0.3;\n  cursor: default;\n  background: #0079ff;\n  text-align: center;\n  line-height: 50px;\n  color: #fff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n.cancel-button-phone {\n  cursor: pointer;\n  background: #fff;\n  text-align: center;\n  line-height: 50px;\n  color: #0079ff;\n  font-size: 1rem;\n  border: 0.5px solid #0079ff;\n  width: 160px;\n  height: 50px;\n  border-radius: 6px\n}\n\n\n.gradient-text {\n  background: linear-gradient(to right, #00c6ff, #0072ff, #ff6a00, #ee0979);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text; /* pour compatibilité étendue */\n  color: transparent;\n}\n\n\n.gradient-text-b {\n  background: linear-gradient(to right, #4300e6, #237f8c, #1d9b69, #1d9b69);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text; /* pour compatibilité étendue */\n  color: transparent;\n}\n\n\n.skeleton {\n  margin-right: 20px;\n  background-color: #ccc;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #777;\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 20px;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.skeleton::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  height: 100%;\n  width: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent);\n  animation: shimmer 2s infinite;\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(0); }\n  100% { transform: translateX(100%); }\n}\n\n\n.popup-box {\n  overflow: hidden;\n  position: relative;\n  min-width: 280px;\n  border-radius: 8px;\n}\n\n.popup-container {\n  background: white;\n  width: 100%;\n  max-height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.popup-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.close-button {\n  background: none;\n  border: none;\n  font-size: 16px;\n  cursor: pointer;\n  color: #888;\n}\n\n.tabs {\n  display: flex;\n  gap: 10px;\n  border-bottom: 1px solid #ddd;\n}\n\n.tab-button {\n  background: none;\n  border: none;\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 16px;\n  transition: transform 0.2s ease;\n  border-bottom: 4px solid #fff;\n}\n\n.tab-button:hover {\n  transform: scale(1);\n  background-color: #eff2fb;\n}\n\n.tab-button.active {\n  border-bottom: 4px solid #0b49ff;\n  color: #0b49ff;\n}\n\n\n.tab-button-phone {\n  background: none;\n  border: none;\n  padding: 4px 6px;\n  cursor: pointer;\n  font-size: 13px;\n  transition: transform 0.2s ease;\n  border-bottom: 4px solid #fff;\n}\n\n.tab-button-phone:hover {\n  transform: scale(1);\n  background-color: #eff2fb;\n}\n\n.tab-button-phone.active {\n  border-bottom: 4px solid #0b49ff;\n  color: #0b49ff;\n}\n\n\n.tab-icon {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.icon .reaction-img {\n  width: 24px;\n  height: 24px;\n  object-fit: contain;\n}\n\n\n.tab-icon-phone {\n  display: flex;\n  align-items: center;\n  gap: 0px;\n}\n.icon-phone .reaction-img {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.count {\n  font-size: 13px;\n  color: #555;\n}\n\n.popup-content {\n  background-color: 'yellow';\n  overflow-y: auto;\n  flex: 1;\n}\n\n.reaction-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 6px 0;\n}\n\n.avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: #ccc;\n}\n\n.no-reactions {\n  text-align: center;\n  color: #888;\n  font-size: 14px;\n  margin-top: 20px;\n}\n\n\n.reaction-container {\n  position: relative;\n  display: inline-block;\n}\n\n.react-button {\n  padding: 8px 12px;\n  background: #fafafa;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.react-button-selected {\n  padding: 8px 12px;\n  background: #f2f5fc;\n  border: 1px solid #0b49ff;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.button-icon {\n  width: 20px;\n  height: 20px;\n}\n\n\n\n.reaction-popover {\n  position: absolute;\n  top: -10px;\n  left: -10px;\n  transform: translateX(0%) translateY(-10%);\n  background: white;\n  border-radius: 40px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.3);\n  padding: 8px 10px;\n  display: flex;\n  gap: 13px;\n  z-index: 100;\n}\n\n.reaction-popover-mobile {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  transform: translateX(0%) translateY(-10%);\n  background: white;\n  border-radius: 40px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.3);\n  padding: 8px 10px;\n  display: flex;\n  gap: 13px;\n  z-index: 100;\n}\n\n.reaction-item {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  cursor: pointer;\n  transition: transform 0.2s ease;\n}\n\n.reaction-item:hover {\n  transform: scale(1.2);\n}\n\n.reaction-item.active .reaction-icon {\n  border: 2px solid #4300ea;\n  border-radius: 50%;\n  padding: 2px;\n}\n\n.reaction-icon {\n  width: 50px;\n  height: 50px;\n}\n\n.counter {\n  margin-top: 4px;\n  font-size: 12px;\n  background: #eee;\n  padding: 2px 6px;\n  border-radius: 10px;\n}\n\n.tooltip {\n  position: absolute;\n  bottom: -30px;\n  background: #4300ea;\n  color: white;\n  padding: 4px 8px;\n  font-size: 11px;\n  border-radius: 4px;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.2s ease;\n  white-space: nowrap;\n}\n\n.reaction-item:hover .tooltip {\n  opacity: 1;\n}\n\n.slider-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n  overflow: hidden;\n}\n\n.image-wrapper {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.slider-image {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  position: absolute;\n  top: 0;\n  left: 0;\n}\n\n.arrow {\n  font-size: 40px;\n  padding: 10px;\n  cursor: pointer;\n  z-index: 2;\n  color: white;\n  user-select: none;\n  background-color: rgba(255,255,255,0.1);\n}\n\n\n.card-content-wrapper{\n  box-shadow: 0px 0px 1px rgba(0, 0, 0, 1) !important; /* modifie le shadow */\n  border-radius: 0px !important; /* arrondi les coins */\n}\n\n\n\n\n.text {\n  overflow: hidden;\n  transition: max-height 0.3s ease;\n}\n\n.collapsed {\n  max-height: 120px; /* ajustable selon besoin */\n}\n\n.expanded {\n  max-height: 1000px;\n}\n\n.toggle-button {\n  margin-top: 5px;\n  background: none;\n  border: 1px solid #0b49ff;\n  color: #0b49ff;\n  cursor: pointer;\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.carousel-wrapper {\n  position: relative;\n  overflow: visible;\n}\n\n.carousel {\n  display: flex;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  padding: 0 60px;\n  padding-bottom: 40px;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge */\n}\n\n.carousel::-webkit-scrollbar {\n  display: none;\n}\n\n.item {\n  margin-right: 20px;\n  background-color: #ddd;\n  border-radius: 10px;\n  overflow: hidden;\n  border: 1px solid #777;\n  flex-shrink: 0;\n  display: flex;\n  align-items: flex-end;\n  padding-bottom: 20px;\n  justify-content: center;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n}\n\n.card-image {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  top: 0;\n  left: 0;\n}\n\n/* Overlay texte en bas */\n.text-overlay {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  padding: 0px;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-start;\n  z-index: 2;\n}\n\n/* Dégradé juste au-dessus du texte */\n.text-gradient {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n  height: calc(3.5em + 10px);\n  background: linear-gradient(to top, rgba(0, 0, 0, 1), transparent);\n  z-index: 1;\n  pointer-events: none;\n}\n\n/* Texte blanc lisible avec ombre */\n.overlay-text {\n  position: relative;\n  color: white;\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 1);\n  margin: 10px;\n  z-index: 2;\n}\n\n.zoom-preview {\n  position: absolute;\n  background-color: #f4f4f4;\n  border-radius: 12px;\n  height: 290px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  pointer-events: none;\n}\n\n.item-wrapper {\n  position: relative;\n  width: 300px;\n  height: 200px;\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.item-content {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #ddd;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  cursor: pointer;\n}\n\n.item-selected {\n  width: 500px;\n  height: 350px;\n  background-color: green;\n  margin-right: 12px;\n  border-radius: 10px;\n  flex-shrink: 0;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: box-shadow 0.3s ease;\n  position: relative;\n  margin-top: -100px;\n  z-index: 999;\n}\n\n\n.scroll-snap-container {\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n}\n\n.header-section {\n  height: 33vh;\n}\n\n\n.scroll-area {\n  height: 100vh;\n  scroll-snap-type: y mandatory;\n  overflow-y: scroll;\n  transition: scroll-snap-type 0.3s ease-in-out;\n}\n\n.disable-scroll-area {\n  overflow-y: scroll;\n}\n\n._scroll-area {\n  max-height: 100vh;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  position: relative;\n}\n\n.section {\n  height: 100vh;\n  scroll-snap-align: start;\n}\n\n.credits-gradient-text {\n  background: linear-gradient(to right, #3e00e6, #2a63a8, #2a63a8, #1c9a68, #1c9a68, #1c9a68, #1c9a68, #1c9a68, #1c9a68);\n  display: inline-block;\n  min-width: 200px; /* donne de l'espace au gradient */\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text; /* pour compatibilité étendue */\n  color: transparent;\n}\n\n.full-page {\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n      height: 100vh;\n      width: 100%;\n}\n\n.home-full-page {\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n      height: 85vh;\n      width: 100%;\n}\n\n\n\n.header-full-page-pc {\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n      height: 'auto';\n      width: 100%;\n}\n\n.sticky-header-full-page-pc {\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n      height: 60px;\n      width: 100%;\n}\n\n.sticky-header-full-page-phone {\n      background-size: cover;\n      background-position: center;\n      background-repeat: no-repeat;\n      height: 130px;\n      width: 100%;\n}\n\n\n\n\n.video-container {\n  position: relative;\n  width: 100%;\n  height: 100vh; /* full viewport height */\n  overflow: hidden;\n}\n\n.video-bg {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: 0;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n.video-bg-mobile {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: 0;\n  transform: translate(-42%, -50%);\n  object-fit: cover;\n}\n\n\n.video-bg-tablet {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: 0;\n  transform: translate(-42%, -50%);\n  object-fit: cover;\n}\n\n.video-bg-mobile-flag {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: 0;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n\n.video-bg-tablet-flag {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  width: auto;\n  height: auto;\n  z-index: 0;\n  transform: translate(-50%, -50%);\n  object-fit: cover;\n}\n\n.content-overlay {\n  position: relative;\n  z-index: 1;\n  color: white;\n  text-align: center;\n  padding-top: 20vh;\n}\n\n\n\n.gradient-box {\n  background: linear-gradient(to right, #333ac9, #1b9868);\n}\n\n@keyframes shine {\n  0% { background-position: -200% 0; }\n  100% { background-position: 200% 0; }\n}\n\n.gradient-background {\n  background-color: #dcddf7;\n  position: relative;\n  overflow: hidden;\n}\n\n.gradient-background::after {\n  content: \"\";\n  position: absolute;\n  top: 80%;\n  left: 0;\n  width: 100%;\n  height: 20%;\n  background: linear-gradient(to bottom, rgba(220, 221, 247, 1), rgba(220, 221, 247, 0));\n  pointer-events: none;\n}\n\n/* Text Input */\n.basic_ti{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;width:358px;\n\tborder:1px solid #111;\n\tborder-radius:4px;\n}\n.basic_ti_top{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;\n  width:358px;\n\tborder:1px solid #111;\n\tborder-radius:4px;\n\tborder-bottom:none;\n\t-moz-border-radius-bottomleft:0px;\n\t\t-webkit-border-bottom-left-radius:0px;\n\t\tborder-bottom-left-radius:0px;\n\t\t-moz-border-radius-bottomright:0px;\n\t\t-webkit-border-bottom-right-radius:0px;\n\t\tborder-bottom-right-radius:0px;\n}\n.basic_ti_middle{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;\n  width:358px;\n\tborder:1px solid #111;border-top:1px solid #bbb;\n\tborder-bottom:none;\n\tborder-radius:none;\n\t-moz-border-radius-topleft:0px;\n\t\t\t-webkit-border-radius:0px;\n\t\t\tborder-radius:0px;\n\t\t\t-moz-border-radius:0px;\n\t\t\t-webkit-border-radius:0px;\n\t\t\tborder-radius:0px;\n}\n.basic_ti_bottom{\n\theight:40px;\n\tpadding:6px;\n\tbackground:#fff;width:358px;\n      border-radius:4px;\n\tborder:1px solid #111;border-top:1px solid #bbb;\n\t-moz-border-radius-topleft:0px;\n\t\t\t-webkit-border-top-left-radius:0px;\n\t\t\tborder-top-left-radius:0px;\n\t\t\t-moz-border-radius-topright:0px;\n\t\t\t-webkit-border-top-right-radius:0px;\n\t\t\tborder-top-right-radius:0px;\n}\n\n/* BUTTON */\n.buttonBlackText {\n\tcolor: #000;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n    line-height: 50px;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n.buttonWhiteText {\n\tcolor: #fff;\n      font-size: 1.3rem;\n     font-weight: 400;\n     text-align: center;\n     width: 200px ;\n\t height: 50px;\n     justify-content: center;\n    line-height: 50px;\n   border-radius: 6px;\n   cursor:pointer;\n}\n\n\n\n.sp-lp-title-pc {\n  font-size: 2rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .sp-lp-title-pc {\n    font-size: 2.5rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .sp-lp-title-pc {\n    font-size: 2.8rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n\n\n.sp-lp-title-sub-pc {\n  font-size: 1.7rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .sp-lp-title-sub-pc {\n    font-size: 2.2rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .sp-lp-title-sub-pc {\n    font-size: 2.5rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n\n\n.sp-lp-title-tablet {\n  font-size: 1.9rem;\n  line-height: 2.2rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n.sp-lp-title-sub-tablet {\n  font-size: 1.7rem;\n  line-height: 2.2rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n\n.sp-lp-title-phone {\n  font-size: 1.1rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n.sp-lp-title-sub-phone {\n  font-size: 0.9rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n\n.sp-lp-h3-pc {\n  font-size: 0.9rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .sp-lp-h3-pc {\n    font-size: 1.2rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .sp-lp-h3-pc {\n    font-size: 1.5rem;\n    font-weight: bold;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n\n\n\n.sp-lp-description-pc {\n  font-size: 0.9rem;\n  line-height: 1.1rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .sp-lp-description-pc {\n    font-size: 1.1rem;\n    line-height: 1.3rem;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .sp-lp-description-pc {\n    font-size: 1.3rem;\n    line-height: 1.5rem;\n    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n}\n\n.sp-lp-description-phone {\n  font-size: 0.9rem;\n  line-height: 1.0rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n.sp-lp-description-tablet {\n  font-size: 1.3rem;\n  line-height: 1.6rem;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n\n.no-sp-inner-shadow {\n  font: bold 30px arial, sans-serif;\n  text-align: center;\n  background-color: #56626e;\n  color: transparent;\n  text-shadow: 2px 2px 3px rgba(255,255,255,0.5);\n  -webkit-background-clip: text;\n     -moz-background-clip: text;\n          background-clip: text;\n}\n\n\n.sp-lp-button-text-white-inner-pc {\n  font-size: 0.9rem;\n  color: #fff;\n  text-shadow: 1px 1px 0 #999,\n              -1px -1px 0 #555;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .sp-lp-button-text-white-inner-pc {\n    font-size: 1.2rem;\n    color: #fff;\n    text-shadow: 1px 1px 0 #999,\n                -1px -1px 0 #555;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .sp-lp-button-text-white-inner-pc {\n    font-size: 1.5rem;\n    color: #fff;\n    text-shadow: 1px 1px 0 #999,\n                -1px -1px 0 #555;\n  }\n}\n\n\n\n\n.hero-section {\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.parallax-bg {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n}\n\n.hero-content {\n  position: relative;\n  z-index: 10;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 0 1rem;\n}\n\n.hero-title {\n  color: #fff;\n  font-size: 3rem;\n  line-height: 3.1rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n\n\n.highlight {\n  color: #facc15; /* jaune doré */\n}\n\n.hero-subtitle {\n  margin-top: 1rem;\n  font-size: 2.3rem;\n  line-height: 2rem;\n  color: white;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n\n\n\n\n\n.hero-title-pc {\n  color: #fff;\n  font-size: 2.4rem;\n  line-height: 2.6rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .hero-title-pc {\n    font-size: 2.6rem;\n    line-height: 2.7rem;\n  }\n}\n\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .hero-title-pc {\n    font-size: 3rem;\n    line-height: 3.1rem;\n  }\n}\n\n.hero-title-mobile {\n  color: #fff;\n  font-size: 2.5rem;\n  line-height: 2.6rem;\n  font-weight: bold;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n\n\n.highlight {\n  color: #facc15; /* jaune doré */\n}\n\n.hero-subtitle {\n  margin-top: 1rem;\n  font-size: 2.3rem;\n  line-height: 2rem;\n  color: white;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.8);\n}\n\n.big-dec-txt-pc {\n  font-size: 5rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .big-dec-txt-pc {\n    font-size: 6.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .big-dec-txt-pc {\n    font-size: 8rem;\n  }\n}\n\n\n.mid-dec-txt-pc {\n  font-size: 3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .mid-dec-txt-pc {\n    font-size: 4.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .mid-dec-txt-pc {\n    font-size: 4rem;\n  }\n}\n\n\n.mid-dec-txt-tablet {\n  font-size: 3.3rem;\n}\n\n.mid-dec-txt-phone {\n  font-size: 2rem;\n}\n\n\n\n.big-dec-txt-subtxt-pc {\n  font-size: 1.6rem;\n  line-height: 1.8rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .big-dec-txt-subtxt-pc {\n    font-size: 1.8rem;\n    line-height: 2rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .big-dec-txt-subtxt-pc {\n    font-size: 2rem;\n    line-height: 2.2rem;\n  }\n}\n\n\n\n\n\n\n.small-box-txt-sz-pc {\n  font-size: 21px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .small-box-txt-sz-pc {\n    font-size: 25px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .small-box-txt-sz-pc {\n    font-size: 5rem;\n  }\n}\n\n\n.small-box-small-txt-sz-pc {\n  font-size: 17px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .small-box-small-txt-sz-pc {\n    font-size: 18px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .small-box-small-txt-sz-pc {\n    font-size: 20px;\n  }\n}\n\n\n.page-title-phone {\n  font-size: 1.8rem;\n}\n\n\n.page-title-pc {\n  font-size: 2.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-title-pc {\n    font-size: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-title-pc {\n    font-size: 2.7rem;\n  }\n}\n\n.page-subtitle-pc {\n  font-size: 2rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-subtitle-pc {\n    font-size: 2.3rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-subtitle-pc {\n    font-size: 2.5rem;\n  }\n}\n\n\n.page-subsubtitle-pc {\n  font-size: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .page-subsubtitle-pc {\n    font-size: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .page-subsubtitle-pc {\n    font-size: 1.7rem;\n  }\n}\n\n\n.page-subsubtitle-phone {\n  font-size: 1rem;\n  line-height: 1.2rem;\n}\n\n\n.menu-name-pc {\n  font-size: 16px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .menu-name-pc {\n    font-size: 17px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .menu-name-pc {\n    font-size: 18px;\n  }\n}\n\n\n.menu-name-tablet {\n  font-size: 17px;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .menu-name-tablet {\n    font-size: 18px;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .menu-name-tablet {\n    font-size: 19px;\n  }\n}\n\n\n.motion-h1-pc {\n  font-size: 2rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-h1-pc {\n    font-size: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-h1-pc {\n    font-size: 2.8rem;\n  }\n}\n\n.motion-h1-sub-pc {\n  font-size: 1.7rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-h1-sub-pc {\n    font-size: 1.8rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-h1-sub-pc {\n    font-size: 1.9rem;\n  }\n}\n\n\n.motion-h1-sub-sub-pc {\n  font-size: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-h1-sub-sub-pc {\n    font-size: 1.4rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-h1-sub-sub-pc {\n    font-size: 1.5rem;\n  }\n}\n\n\n.motion-h1-sub-phone {\n  font-size: 1.4rem;\n}\n\n\n.img-border-radius-pc {\n  border-radius: 0.7rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .img-border-radius-pc {\n    border-radius: 0.9rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .img-border-radius-pc {\n    border-radius: 1rem;\n  }\n}\n\n\n\n.motion-div-small-pc {\n  font-size: 1rem;\n  line-height: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-small-pc {\n    font-size: 1.2rem;\n    line-height: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-small-pc {\n    font-size: 1.5rem;\n    line-height: 1.8rem;\n  }\n}\n\n\n.motion-div-small-tablet {\n  font-size: 1.3rem;\n  line-height: 1.6rem;\n}\n\n.motion-div-small-phone {\n  font-size: 1rem;\n  line-height: 1.2rem;\n}\n\n\n.motion-div-smallest-tablet {\n  font-size: 1.5rem;\n  line-height: 1.8rem;\n}\n\n.motion-div-smallest-phone {\n  font-size: 1.0rem;\n  line-height: 1.3rem;\n}\n\n\n.motion-div-smallest-pc {\n  font-size: 0.9rem;\n  line-height: 1.1rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-smallest-pc {\n    font-size: 1.1rem;\n    line-height: 1.3rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-smallest-pc {\n    font-size: 1.3rem;\n    line-height: 1.5rem;\n  }\n}\n\n\n\n.motion-div-default-pc {\n  font-size: 1.1rem;\n  line-height: 1.3rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-default-pc {\n    font-size: 1.3rem;\n    line-height: 1.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-default-pc {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n  }\n}\n\n\n\n.motion-div-title-pc {\n  font-size: 1.7rem;\n  line-height: 1.9rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-title-pc {\n    font-size: 2.3rem;\n    line-height: 2.5rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-title-pc {\n    font-size: 2.5rem;\n    line-height: 2.7rem;\n  }\n}\n\n\n\n.motion-div-subtitle-pc {\n  font-size: 1.4rem;\n  line-height: 1.6rem;\n}\n/* Between 1201px and 1400px */\n@media (min-width: 1201px) and (max-width: 1400px) {\n  .motion-div-subtitle-pc {\n    font-size: 2rem;\n    line-height: 2.2rem;\n  }\n}\n/* Above 1400px */\n@media (min-width: 1401px) {\n  .motion-div-subtitle-pc {\n    font-size: 2.2rem;\n    line-height: 2.4rem;\n  }\n}\n\n\n\n\n\n.blurred-transp-bg {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.menu-modal-transl {\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n\n/* HEADER */\n.main_header {\n  position:fixed;\n\tz-index:19;\n\ttop:10px;\n\tright: 25px;\n   width: 100%;\n   height: 70px;\n  border-bottom: rgba(53,3,176,1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.main_header_okd {\n\tposition:fixed;\n\tz-index:99;\n\ttop:0;\n\tleft: 0;\n   width: 100%;\n   height: 70px;\n  border-bottom: rgba(53,3,176,1);\n  background: rgb(53,3,176);\nbackground: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nbackground: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nbackground: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\nfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#3503b0\",endColorstr=\"#9e10bf\",GradientType=1);\n}\n\n.main_header_connected{\n\tposition:fixed;\n\tz-index:9;\n\ttop:0;\n\tleft: 0;\n   width: 100%;\n   height: 70px;\n   background: rgb(53,3,176);\n background: -moz-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n background: -webkit-linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n background: linear-gradient(83deg, rgba(53,3,176,1) 0%, rgba(158,16,191,1) 100%);\n filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#3503b0\",endColorstr=\"#9e10bf\",GradientType=1);\n  overflow: hidden;\n}\n\n\n.main_header_inside {\n\twidth: 98%;\n       height: 60px;\n\tmargin: auto;\n\tmargin-top:5px;\n      overflow: hidden;\n}\n\n.main_header_inside_mobile {\n\twidth: 98%;\n       height: 50px;\n\tmargin: auto;\n\tmargin-top:5px;\n      overflow: hidden;\n}\n\n\n\n\n.main_header_inside_left {\n       width: 170px;\n       height: 50px;\n\t    justify-content: center;\n\t   line-height: 50px;\n\t   float: left;\n}\n\n.main_header_inside_left_2 {\n       height: 65px;\n\t    justify-content: center;\n\t   line-height: 65px;\n\t   float: left;\n\t   margin-left: 50px;\n}\n\n.main_header_inside_left_2 a{\n\tdisplay: inline-block;\n\ttext-align: center;\n\tfont-size: 17px;\n  margin-right: 25px\n}\n\n\n.main_header_inside_left img{\n\twidth: 170px;\n\t vertical-align: middle;\n}\n\n.main_header_inside_left_mobile {\n\twidth: 30%;\n       height: 50px;\n\t    justify-content: center;\n\t   line-height: 50px;\n\t   float: left;\n}\n.main_header_inside_left_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n\n.main_header_inside_center {\n\tmargin-left: 20px;\n\twidth: 480px;\n       height: 44px;\n\t   margin-top:3px;\n    justify-content: center;\n\t float: left;\n}\n\n\n\n\n.main_header_inside_center_mobile {\n\ttext-align:  center;\n\twidth: 40%;\n       height: 50px;\n\t   line-height: 50px;\n\t   float: left;\n}\n.main_header_inside_center_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n.main_header_inside_right {\n\tposition: relative;\n\ttext-align:  right;\n\twidth: 350px;\n       height: 50px;\n\t   float: right;\n}\n.main_header_inside_right img{\n\theight: 50px;\n\t vertical-align: middle;\n}\n\n\n.main_header_inside_right_1 {\n\tposition: relative;\n\t   float: right;\n\t   margin-left:20px;\n\t     margin-top:5px;\n}\n\n.main_header_inside_right_2 {\n\tposition: relative;\n\t   float: right;\n\t   margin-top:5px;\n}\n\n\n.main_header_inside_right_mobile {\n\tposition: relative;\n\ttext-align:  right;\n\twidth: 30%;\n       height: 50px;\n\t     line-height: 50px;\n\t   float: right;\n}\n.main_header_inside_right_mobile img{\n\twidth: 100%;\n\t vertical-align: middle;\n}\n\n\n\n.menu_container {\n  position: fixed;\n  top: 19px;\n  right: 7px;\n  height: 27px;\n  width: 35px;\n  cursor: pointer;\n  z-index: 9999;\n  transition: opacity .25s ease;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &.active {\n    .top {\n      transform: translateY(11px) translateX(0) rotate(45deg);\n      background: #777;\n    }\n    .middle {\n      opacity: 0;\n      background: #777;\n    }\n\n    .bottom {\n      transform: translateY(-11px) translateX(0) rotate(-45deg);\n      background: #777;\n    }\n  }\n\n  span {\n  background: #fff;\n  border: none;\n  height: 3px;\n  width: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition:  all .35s ease;\n  cursor: pointer;\n\n    &:nth-of-type(2) {\n      top: 11px;\n    }\n\n    &:nth-of-type(3) {\n      top: 22px;\n    }\n  }\n}\n\n\n\n.overlay {\n  position: fixed;\n   z-index: 10;\n  background: #fff;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 0%;\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity .35s, visibility .35s, height .35s;\n  overflow: hidden;\n\n  &.open {\n    opacity: 1;\n    visibility: visible;\n    height: 100%;\n\n    li {\n      animation: fadeInRight .5s ease forwards;\n      animation-delay: .35s;\n\n      &:nth-of-type(2) {\n        animation-delay: .4s;\n      }\n      &:nth-of-type(3) {\n        animation-delay: .45s;\n      }\n      &:nth-of-type(4) {\n        animation-delay: .50s;\n      }\n    }\n  }\n  nav {\n    position: relative;\n    height: 70%;\n    top: 35%;\n    transform: translateY(-50%);\n    font-size: 20px;\n    font-family: 'Lato', sans-serif;\n    font-weight: 400;\n    text-align: center;\n    width: 98% ;\n\tmargin: auto;\n  }\n  ul {\n    list-style: none;\n    padding: 0;\n    margin: 0 auto;\n    display: inline-block;\n    position: relative;\n    height: 100%;\n     width: 100% ;\n\n    li {\n      display: block;\n      height: 50px;\n      min-height: 50px;\n\t  line-height: 50px;\n\t  width: 100% ;\n      position: relative;\n      opacity: 0;\n\n      a {\n        display: block;\n        position: relative;\n        color: #333;\n        text-decoration: none;\n        overflow: hidden;\n        vertical-align: middle;\n\n        &:hover:after,\n         &:focus:after,\n         &:active:after {\n           width: 100%;\n         }\n\n        &:after {\n          content: '';\n          position: absolute;\n          bottom: 0;\n          left: 50%;\n          width: 0%;\n          transform: translateX(-50%);\n          height: 3px;\n          background: #FFF;\n          transition: .35s;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
